import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  slots: [],
  activities: [],
  remainders: [],
  labels:[],
  careplanStatuses: [],
  dimensions: [],
  dimensionActivities: {}, // Cache activities by dimension/category id
}

const lookupsSlice = createSlice({
    name: 'lookups',
    initialState,
    reducers: {
        updateSlots: (state, action) => {
            state.slots = action.payload
        },
        fetchActivities: (state, action) => {
            state.activities = action.payload   
        },
        fetchRemainders: (state, action) => {
            state.remainders = action.payload
        },
        fetchLabels: (state, action) => {
            state.labels = action.payload
        },
        updateCareplanStatuses: (state, action) => {
            state.careplanStatuses = action.payload
        },
        updateDimensions: (state, action) => {
            state.dimensions = action.payload
        },
        updateDimensionActivities: (state, action) => {
            const { categoryId, activities } = action.payload
            state.dimensionActivities[categoryId] = activities
        }
    }
})

export const {updateSlots,fetchActivities,fetchRemainders,fetchLabels, updateCareplanStatuses, updateDimensions, updateDimensionActivities} = lookupsSlice.actions

export default lookupsSlice.reducer;